// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.settings-search {
  position: relative;
  display: block;
}
.settings-search > i {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: #94a3b8;
}
.settings-search input {
  width: 100%;
  padding-left: 36px;
  padding-right: 34px;
}
.settings-search .clear {
  position: absolute;
  right: 6px;
  top: 50%;
  transform: translateY(-50%);
  border: 0;
  background: transparent;
  color: #94a3b8;
  cursor: pointer;
  padding: 6px;
  border-radius: 4px;
}
.settings-search .clear:hover {
  background: #f1f5f9;
  color: #0f172a;
}
.settings {
  max-width: 1100px;
}
.settings .settings-group {
  margin-bottom: 28px;
}
.settings .settings-group h4 {
  margin: 0 0 12px;
  font-size: 0.75rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: #64748b;
}
.settings .settings-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 14px;
}
.settings .settings-tile {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 16px;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  color: inherit;
  text-decoration: none;
  box-shadow: 0 4px 16px -12px rgba(15, 23, 42, 0.3);
  transition: border-color 0.15s, box-shadow 0.15s, transform 0.15s;
}
.settings .settings-tile:hover {
  border-color: #0f766e;
  box-shadow: 0 10px 24px -14px rgba(15, 118, 110, 0.55);
  transform: translateY(-1px);
}
.settings .settings-tile:hover .chevron {
  color: #0f766e;
  transform: translateX(2px);
}
.settings .settings-tile .icon {
  flex: none;
  width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  background: #ccfbf1;
  color: #0f766e;
  font-size: 1.1rem;
}
.settings .settings-tile .text {
  flex: 1;
  min-width: 0;
}
.settings .settings-tile .text strong {
  display: block;
  font-size: 0.95rem;
  color: #0f172a;
}
.settings .settings-tile .text small {
  display: block;
  margin-top: 2px;
  font-size: 0.8rem;
  line-height: 1.35;
  color: #64748b;
}
.settings .settings-tile .chevron {
  color: #cbd5e1;
  transition: color 0.15s, transform 0.15s;
}
.settings .settings-empty {
  padding: 40px 0;
  text-align: center;
  color: #64748b;
}
/*# sourceMappingURL=settings.component.css.map */`, "",{"version":3,"sources":["webpack://./settings.component.less","webpack://./src/app/settings/settings.component.less"],"names":[],"mappings":"AAEA;EACE,kBAAA;EACA,cAAA;ACDF;ADDA;EAKI,kBAAA;EACA,UAAA;EACA,QAAA;EACA,2BAAA;EACA,cAAA;ACDJ;ADRA;EAaI,WAAA;EACA,kBAAA;EACA,mBAAA;ACFJ;ADbA;EAmBI,kBAAA;EACA,UAAA;EACA,QAAA;EACA,2BAAA;EACA,SAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;ACHJ;ADKI;EACE,mBAAA;EACA,cAAA;ACHN;ADQA;EACE,iBAAA;ACNF;ADKA;EAII,mBAAA;ACNJ;ADEA;EAOM,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,cAAA;ACNN;ADNA;EAiBI,aAAA;EACA,4DAAA;EACA,SAAA;ACRJ;ADXA;EAuBI,aAAA;EACA,mBAAA;EACA,SAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,cAAA;EACA,qBAAA;EACA,kDAAA;EACA,iEAAA;ACTJ;ADWI;EACE,qBAAA;EACA,sDAAA;EACA,2BAAA;ACTN;ADMI;EAMI,cAAA;EACA,0BAAA;ACTR;ADjCA;EA+CM,UAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,cAAA;EACA,iBAAA;ACXN;AD7CA;EA4DM,OAAA;EACA,YAAA;ACZN;ADjDA;EAgEQ,cAAA;EACA,kBAAA;EACA,cAAA;ACZR;ADtDA;EAsEQ,cAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,cAAA;ACbR;AD7DA;EA+EM,cAAA;EACA,wCAAA;ACfN;ADjEA;EAqFI,eAAA;EACA,kBAAA;EACA,cAAA;ACjBJ;AACA,iDAAiD","sourcesContent":["@import (reference) \"../../assets/less/colors.less\";\n\n.settings-search {\n  position: relative;\n  display: block;\n\n  > i {\n    position: absolute;\n    left: 12px;\n    top: 50%;\n    transform: translateY(-50%);\n    color: #94a3b8;\n  }\n\n  input {\n    width: 100%;\n    padding-left: 36px;\n    padding-right: 34px;\n  }\n\n  .clear {\n    position: absolute;\n    right: 6px;\n    top: 50%;\n    transform: translateY(-50%);\n    border: 0;\n    background: transparent;\n    color: #94a3b8;\n    cursor: pointer;\n    padding: 6px;\n    border-radius: 4px;\n\n    &:hover {\n      background: #f1f5f9;\n      color: #0f172a;\n    }\n  }\n}\n\n.settings {\n  max-width: 1100px;\n\n  .settings-group {\n    margin-bottom: 28px;\n\n    h4 {\n      margin: 0 0 12px;\n      font-size: 0.75rem;\n      font-weight: 700;\n      text-transform: uppercase;\n      letter-spacing: 0.08em;\n      color: #64748b;\n    }\n  }\n\n  .settings-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\n    gap: 14px;\n  }\n\n  .settings-tile {\n    display: flex;\n    align-items: center;\n    gap: 14px;\n    padding: 16px;\n    background: @white;\n    border: 1px solid #e5e7eb;\n    border-radius: 12px;\n    color: inherit;\n    text-decoration: none;\n    box-shadow: 0 4px 16px -12px rgba(15, 23, 42, 0.3);\n    transition: border-color 0.15s, box-shadow 0.15s, transform 0.15s;\n\n    &:hover {\n      border-color: #0f766e;\n      box-shadow: 0 10px 24px -14px rgba(15, 118, 110, 0.55);\n      transform: translateY(-1px);\n\n      .chevron {\n        color: #0f766e;\n        transform: translateX(2px);\n      }\n    }\n\n    .icon {\n      flex: none;\n      width: 44px;\n      height: 44px;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      border-radius: 10px;\n      background: #ccfbf1;\n      color: #0f766e;\n      font-size: 1.1rem;\n    }\n\n    .text {\n      flex: 1;\n      min-width: 0;\n\n      strong {\n        display: block;\n        font-size: 0.95rem;\n        color: #0f172a;\n      }\n\n      small {\n        display: block;\n        margin-top: 2px;\n        font-size: 0.8rem;\n        line-height: 1.35;\n        color: #64748b;\n      }\n    }\n\n    .chevron {\n      color: #cbd5e1;\n      transition: color 0.15s, transform 0.15s;\n    }\n  }\n\n  .settings-empty {\n    padding: 40px 0;\n    text-align: center;\n    color: #64748b;\n  }\n}\n",".settings-search {\n  position: relative;\n  display: block;\n}\n.settings-search > i {\n  position: absolute;\n  left: 12px;\n  top: 50%;\n  transform: translateY(-50%);\n  color: #94a3b8;\n}\n.settings-search input {\n  width: 100%;\n  padding-left: 36px;\n  padding-right: 34px;\n}\n.settings-search .clear {\n  position: absolute;\n  right: 6px;\n  top: 50%;\n  transform: translateY(-50%);\n  border: 0;\n  background: transparent;\n  color: #94a3b8;\n  cursor: pointer;\n  padding: 6px;\n  border-radius: 4px;\n}\n.settings-search .clear:hover {\n  background: #f1f5f9;\n  color: #0f172a;\n}\n.settings {\n  max-width: 1100px;\n}\n.settings .settings-group {\n  margin-bottom: 28px;\n}\n.settings .settings-group h4 {\n  margin: 0 0 12px;\n  font-size: 0.75rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n  color: #64748b;\n}\n.settings .settings-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\n  gap: 14px;\n}\n.settings .settings-tile {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  padding: 16px;\n  background: #ffffff;\n  border: 1px solid #e5e7eb;\n  border-radius: 12px;\n  color: inherit;\n  text-decoration: none;\n  box-shadow: 0 4px 16px -12px rgba(15, 23, 42, 0.3);\n  transition: border-color 0.15s, box-shadow 0.15s, transform 0.15s;\n}\n.settings .settings-tile:hover {\n  border-color: #0f766e;\n  box-shadow: 0 10px 24px -14px rgba(15, 118, 110, 0.55);\n  transform: translateY(-1px);\n}\n.settings .settings-tile:hover .chevron {\n  color: #0f766e;\n  transform: translateX(2px);\n}\n.settings .settings-tile .icon {\n  flex: none;\n  width: 44px;\n  height: 44px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 10px;\n  background: #ccfbf1;\n  color: #0f766e;\n  font-size: 1.1rem;\n}\n.settings .settings-tile .text {\n  flex: 1;\n  min-width: 0;\n}\n.settings .settings-tile .text strong {\n  display: block;\n  font-size: 0.95rem;\n  color: #0f172a;\n}\n.settings .settings-tile .text small {\n  display: block;\n  margin-top: 2px;\n  font-size: 0.8rem;\n  line-height: 1.35;\n  color: #64748b;\n}\n.settings .settings-tile .chevron {\n  color: #cbd5e1;\n  transition: color 0.15s, transform 0.15s;\n}\n.settings .settings-empty {\n  padding: 40px 0;\n  text-align: center;\n  color: #64748b;\n}\n/*# sourceMappingURL=settings.component.css.map */"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
